// AppDataGrid — adapter passthrough di `@mui/x-data-grid`.
//
// Obiettivo (DESIGN.md / Fase 4): i componenti di business non importano
// `@mui/x-data-grid` direttamente, ma passano da `@ui`. Questo centralizza
// in un solo punto locale, theming ed eventuali sostituzioni future della
// libreria, senza imporre default visivi ai consumer.
//
// A differenza di `DataTable` (adapter "opinionato": density compact,
// autoHeight, empty state custom), `AppDataGrid` è un passthrough trasparente:
// applica SOLO il locale italiano come default (sovrascrivibile via prop
// `localeText`) e inoltra tutte le altre props a `<DataGrid>`. Pensato per la
// migrazione 1:1 dei consumer esistenti senza regressioni visive.
//
// I named export `GridToolbar`, `GridRow`, `useGridApiContext` sono
// ri-esportati così che anche i file che li usano possano importare tutto da
// `@ui` senza toccare `@mui/x-data-grid`.

import { DataGrid, GridToolbar, GridRow, useGridApiContext } from '@mui/x-data-grid';
import { itIT } from '@mui/x-data-grid/locales';

const IT_LOCALE_TEXT = itIT.components.MuiDataGrid.defaultProps.localeText;

export default function AppDataGrid(props) {
  return <DataGrid localeText={IT_LOCALE_TEXT} {...props} />;
}

export { GridToolbar, GridRow, useGridApiContext };
